import { tokenStorage } from '@/store/TokenStorage'
import { isRedirectToLoginPage } from './checkRedirectToLoginPage'

async function clearOnLogout() {
  const mainStore = await import('@/domains/Account/store').then(
    (m) => m.mainStore
  )

  mainStore.clearOnLogout()
}

export async function fetchWithAuth(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  let token = await tokenStorage.getActualAccessToken()

  const preparedInit = { ...init }
  if (token) {
    preparedInit.headers = {
      ...preparedInit.headers,
      Authorization: `Bearer ${token}`,
    }
  }

  let response = await fetch(input, preparedInit)

  // 403 — доступ запрещён: токен валиден, но права на действие нет.
  // Refresh здесь бессмысленен.
  if (response.status === 403) {
    if (typeof window !== 'undefined') {
      const { toast } = await import('react-toastify')
      toast.error('У вас недостаточно прав для выполнения этой операции')
    }
    return response
  }

  let isUnauthorization = response.status === 401
  let isRedirect = isRedirectToLoginPage(response)

  // Запрос прошел, возвращаем response
  if (!isUnauthorization && !isRedirect) {
    return response
  }

  // Если сервер ответил 401 (UNAUTHENTICATED — токен истёк/невалиден)
  // — обновляем токен и повторяем запрос.
  // 302 - перенаправление на страницу авторизации в админ панель.

  const refreshed = await tokenStorage.refresh()

  // Обновить токен не удалось - выходим из аккаунта
  if (!refreshed) {
    await clearOnLogout()
    return response
  }

  const headers = new Headers(init.headers)
  token = await tokenStorage.getActualAccessToken()

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  } else {
    headers.delete('Authorization')
  }

  response = await fetch(input, { ...init, headers })

  if (response.status === 403) {
    if (typeof window !== 'undefined') {
      const { toast } = await import('react-toastify')
      toast.error('У вас недостаточно прав для выполнения этой операции')
    }
    return response
  }

  // Токен обновился, но сервер снова отвечает 401 — разлогиниваем
  isUnauthorization = response.status === 401
  isRedirect = isRedirectToLoginPage(response)

  if (isUnauthorization || isRedirect) {
    await clearOnLogout()
  }

  return response
}
